import { render } from "./index.vue?vue&type=template&id=32f48a81&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=32f48a81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_c888307087c990cfda5c0d18ef320e2e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f48a81"],['__file',"src/components/scTable/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32f48a81"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32f48a81', __exports__)) {
    api.reload('32f48a81', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=32f48a81&scoped=true", () => {
    api.rerender('32f48a81', render)
  })

}


export default __exports__